document.addEventListener("click", async function (e) {
  const swatch = e.target.closest("[data-family-swatch]");
  if (!swatch) return;

  e.preventDefault();

  const url = swatch.getAttribute("href");
  const root = document.querySelector("[data-product-root]");
  if (!root) return;

  root.classList.add("is-loading");

  try {
    const res = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });

    if (!res.ok) throw new Error("Fetch failed");

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newRoot = doc.querySelector("[data-product-root]");
    if (!newRoot) throw new Error("Product root not found");

    newRoot.classList.add("is-loading");
    root.replaceWith(newRoot);

    requestAnimationFrame(() => {
      newRoot.classList.remove("is-loading");
    });

    history.pushState({}, "", url);

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    document.dispatchEvent(new CustomEvent("product:changed"));
  } catch (err) {
    console.error("Family AJAX error", err);
    window.location.href = url;
  }
});

window.addEventListener("popstate", () => {
  window.location.reload();
});
